<mat-card style="text-align: center">
    <h1>Oops!</h1>
    <h2 style="color: crimson">Error 404:</h2>
    <h3>A keresett oldal sajnos nem található</h3>
    <img
        mat-card-image
        src="../../../assets/css-tricks-404-page.png"
        style="max-width: 477px"
        alt="Error 404"
    />
    <mat-card-content>
        <p>Mit szólnál egy finom kávéhoz, amíg elhárítjuk a problémát? :-)</p>
    </mat-card-content>
</mat-card>
